module.exports = __FOREMAN_VENDOR__UNIDIFF__;